import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Typography, Link, Paper } from '@mui/material';

export const useMarkdown = () => {
  const renderMarkdown = (content: string) => (
    <ReactMarkdown 
      remarkPlugins={[remarkGfm]}
      components={{
        h1: ({node, children}) => (
          <Typography variant="h4" gutterBottom>
            {children}
          </Typography>
        ),
        h2: ({node, children}) => (
          <Typography variant="h5" gutterBottom>
            {children}
          </Typography>
        ),
        h3: ({node, children}) => (
          <Typography variant="h6" gutterBottom>
            {children}
          </Typography>
        ),
        p: ({node, children}) => (
          <Typography variant="body1" paragraph>
            {children}
          </Typography>
        ),
        a: ({node, href, children}) => (
          <Link 
            href={href}
            sx={{ 
              color: 'primary.main',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }} 
          >
            {children}
          </Link>
        ),
        code: ({node, inline, className, children, ...props}: any) => (
          inline ? 
            <code style={{ 
              backgroundColor: 'rgba(0,0,0,0.1)', 
              padding: '2px 4px', 
              borderRadius: 4 
            }} {...props}>
              {children}
            </code> :
            <Paper sx={{ p: 2, my: 2, bgcolor: 'background.default' }}>
              <code style={{ display: 'block' }} {...props}>
                {children}
              </code>
            </Paper>
        ),
        // ... rest of the markdown components
      }}
    >
      {content}
    </ReactMarkdown>
  );

  return { renderMarkdown };
}; 